import { MEMBER_STATUS } from '../constants/copy.js';

/** Statuses of a person who has not signed in yet: they get the placeholder treatment. */
const NOT_SIGNED_IN = [MEMBER_STATUS.NOT_INVITED, MEMBER_STATUS.INVITED, MEMBER_STATUS.EXPIRED];

/** Up to two initials of a display name: "Ana Torres" -> "AT", "natalia.kim" -> "NK". */
export const getInitials = (displayName = '') => {
  const parts = displayName.split(/[\s._-]+/).filter(Boolean);
  if (!parts.length) return '';
  return (parts[0][0] + (parts.length > 1 ? parts[parts.length - 1][0] : '')).toUpperCase();
};

/** The name if there is one, else the email local-part ("natalia.kim@x.com" -> "natalia.kim"). */
export const getMemberDisplayName = ({ name, email } = {}) => {
  const trimmed = (name ?? '').trim();
  // A name equal to the email is the API echoing the address, not a real name.
  if (trimmed && trimmed !== email) return trimmed;
  return (email ?? '').split('@')[0];
};

/**
 * Profile not completed: no name, or the person has not signed in yet (Not invited, Invited,
 * Expired). Such a member shows the generic avatar (no initials) and dashes for MFA / last active.
 */
export const isPlaceholderProfile = ({ name, status } = {}) =>
  !(name ?? '').trim() || NOT_SIGNED_IN.includes(status);

/** The first word of a display name ("Ana Torres" -> "Ana"): how the studio counter and notes address a member. */
export const getFirstName = (displayName = '') => displayName.trim().split(/\s+/)[0] ?? '';
